export enum DefaultColumn {
  MembershipPlanName = 'membershipPlanName',
  Price = 'price',
  Seats = 'seats',
}
